import "./accoardion-with-image-chenge";
import "./common-issue";
import "./collapse-content-by-click";
import "./ampm-accordion";
import "./splash-screen";
